import {
  BlockContentValue,
  SectionContainer
} from "@silversea-ssc/ui-components-react";
import TextBox from "components/TextBox/TextBox";
import React, { PropsWithChildren } from "react";
import * as styles from "./DestinationFaresBox.module.scss";
import { AdditionalCruiseGroupFragment } from "types/graphql-types";
import HighlightedCruiseGroupCard from "./HighlightedCruiseGroupCard";
import FareInfographicBoxDisclaimer from "src/page-components/destinations/DestinationFaresBox/FareInfographicBoxDisclaimer";

type Props = {
  title?: string;
  content?: BlockContentValue;
  additionalCruiseGroupCard?: AdditionalCruiseGroupFragment;
  destinationFilterValue?: string;
  disclaimer?: string;
};

const DestinationFaresBox: React.FC<PropsWithChildren<Props>> = ({
  title,
  content,
  additionalCruiseGroupCard,
  destinationFilterValue,
  disclaimer,
  children
}) => {
  const fycFilter = buildFYCDestinationFilter(destinationFilterValue);
  const urlWithFYCDestinationFilter = `${additionalCruiseGroupCard?.fullPath}${fycFilter}`;

  return (
    <div id="all_inclusive" data-content-name="all_inclusive">
      <SectionContainer backgroundColor="neutral01">
        <div className={styles.header}>
          <div className={styles.headerTitle}>{title}</div>
          <TextBox fontSize="medium" content={content} />
        </div>
      </SectionContainer>

      {children}

      <SectionContainer backgroundColor="white" spacingBottom="regular">
        {additionalCruiseGroupCard?.card && (
          <HighlightedCruiseGroupCard
            className={styles.highlightedCruiseGroupCard}
            image={additionalCruiseGroupCard.card.image}
            title={additionalCruiseGroupCard.card.title?.localized}
            content={additionalCruiseGroupCard.card.description?.localized}
            url={urlWithFYCDestinationFilter}
            trackingName={additionalCruiseGroupCard.metadata?.tracking?.name}
          />
        )}

        {disclaimer && (
          <FareInfographicBoxDisclaimer className={styles.disclaimer}>
            {disclaimer}
          </FareInfographicBoxDisclaimer>
        )}
      </SectionContainer>
    </div>
  );
};

const buildFYCDestinationFilter = (destinationName: string | undefined) => {
  if (!destinationName) return "";

  const urlSearchParams = new URLSearchParams();
  urlSearchParams.set("refinementList[destinationName][0]", destinationName);
  return `?${urlSearchParams.toString()}`;
};

export default DestinationFaresBox;
